import Component from '@glimmer/component'
import RouteTemplate from 'ember-route-template'
import type { QuickStartLabel } from 'teacher-ui-client/components/quick-start-card.gts'
import { QuickStartCard } from 'teacher-ui-client/components/quick-start-card.gts'
import { PageHeader } from 'teacher-ui-client/components/page-header'
import type QuickStartRoute from 'teacher-ui-client/subscription-type/quick-start/route'
import type { QuickStartResourceEntry } from 'teacher-ui-client/contentful-client/entry-types'
import { t } from 'ember-intl'

export interface QuickStartResourceViewModel {
  heading: string
  label: QuickStartLabel
  body: string
  bullets?: string[]
  videoUrl?: string
  pdfUrl?: string
  product: string
}

export function getQuickStartResourceViewModel(entries: QuickStartResourceEntry[]): QuickStartResourceViewModel[] {
  return entries.map((entry) => {
    return {
      heading: entry.fields.heading,
      label: entry.fields.label as QuickStartLabel,
      body: entry.fields.body,
      bullets: entry.fields.bullets,
      videoUrl: entry.fields.video?.fields.file?.url,
      pdfUrl: entry.fields.pdf?.fields.file?.url,
      product: entry.fields.product,
    }
  })
}

interface Signature {
  Args: {
    model: ModelFor<QuickStartRoute>
  }
}

class QuickStartTemplate extends Component<Signature> {
  get quickStartResources() {
    return getQuickStartResourceViewModel(this.args.model.quickStartResources)
  }

  <template>
    <div class="w-full">
      <PageHeader>
        <:title>
          <h1>
            {{t "quickStart"}}
          </h1>
        </:title>
      </PageHeader>
      <div class="mx-auto grid w-fit grid-cols-1 gap-6 xl:grid-cols-2">
        {{#each this.quickStartResources as |quickStartResource|}}
          <QuickStartCard @contentfulQuickStartResource={{quickStartResource}} @matchesTeacherIntent={{false}} />
        {{/each}}
      </div>
    </div>
  </template>
}

export default RouteTemplate(QuickStartTemplate)
